var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:""},[(_vm.isRedirectAfterRedeem)?_c('LoginForRedeemForm',{on:{"success":_vm.setUserData}}):_c('LoginForm',{on:{"success":_vm.setUserData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }